import itemSchema from './schemas/lottery_result.schema';
import ModuleBase from "@/store/modules/ModuleBase";

const resourceName = 'lottery_results'
const base = new ModuleBase(itemSchema, resourceName);
export default {
    namespaced: base.namespaced,
    state: {
        ...base.state,
    },
    getters: {
        ...base.getters,
    },
    mutations: {
        ...base.mutations,
    },
    actions: {
        ...base.actions
    }
}
